import React from 'react';

interface PulsingIndicatorProps {
  status: 'active' | 'processing' | 'error' | 'warning' | 'success';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showText?: boolean;
  text?: string;
}

const PulsingIndicator: React.FC<PulsingIndicatorProps> = ({
  status,
  size = 'md',
  className = '',
  showText = false,
  text
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'active':
        return {
          color: 'bg-blue-500',
          pulseColor: 'bg-blue-400',
          textColor: 'text-blue-600',
          text: text || 'AKTÍV'
        };
      case 'processing':
        return {
          color: 'bg-yellow-500',
          pulseColor: 'bg-yellow-400',
          textColor: 'text-yellow-600',
          text: text || 'FELDOLGOZÁS'
        };
      case 'error':
        return {
          color: 'bg-red-500',
          pulseColor: 'bg-red-400',
          textColor: 'text-red-600',
          text: text || 'HIBA'
        };
      case 'warning':
        return {
          color: 'bg-orange-500',
          pulseColor: 'bg-orange-400',
          textColor: 'text-orange-600',
          text: text || 'FIGYELEM'
        };
      case 'success':
        return {
          color: 'bg-green-500',
          pulseColor: 'bg-green-400',
          textColor: 'text-green-600',
          text: text || 'SIKERES'
        };
      default:
        return {
          color: 'bg-gray-500',
          pulseColor: 'bg-gray-400',
          textColor: 'text-gray-600',
          text: text || 'ISMERETLEN'
        };
    }
  };

  const getSizeConfig = () => {
    switch (size) {
      case 'sm':
        return {
          dot: 'w-2 h-2',
          pulse: 'w-3 h-3',
          text: 'text-xs'
        };
      case 'lg':
        return {
          dot: 'w-4 h-4',
          pulse: 'w-6 h-6',
          text: 'text-sm'
        };
      default: // md
        return {
          dot: 'w-3 h-3',
          pulse: 'w-4 h-4',
          text: 'text-xs'
        };
    }
  };

  const statusConfig = getStatusConfig();
  const sizeConfig = getSizeConfig();

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <div className="relative">
        {/* Pulse effect */}
        <div 
          className={`absolute inset-0 ${statusConfig.pulseColor} ${sizeConfig.pulse} rounded-full animate-ping opacity-75`}
          style={{
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        />
        {/* Main dot */}
        <div className={`relative ${statusConfig.color} ${sizeConfig.dot} rounded-full z-10`} />
      </div>
      
      {showText && (
        <span className={`${statusConfig.textColor} ${sizeConfig.text} font-semibold tracking-wide`}>
          {statusConfig.text}
        </span>
      )}
    </div>
  );
};

export default PulsingIndicator; 